<div class="surface cyber-form">
  <h3 class="section-title">>_ {{ selectedEntity.getNamePl() | uppercase }}</h3>
  <form>

    <div class="form-grid">
      <ng-container *ngFor="let field of fields">
        <div class="form-group" *ngIf="canShowField(field) && field.type !== 'multi-choice'">
          <label>{{ field.label }}</label>

          <ng-container [ngSwitch]="field.type">

            <input *ngSwitchCase="'text'" class="form-control" [(ngModel)]="entityData[field.name]" name="{{ field.name }}" type="text" autocomplete="off"/>

            <input *ngSwitchCase="'password'" class="form-control" [(ngModel)]="entityData[field.name]" name="{{ field.name }}" type="password" autocomplete="new-password" />

            <input *ngSwitchCase="'number'" class="form-control" [(ngModel)]="entityData[field.name]" name="{{ field.name }}" type="number" />

            <input *ngSwitchCase="'date'" class="form-control" [(ngModel)]="formattedInputData[field.name]" name="{{ field.name }}" type="date" />

            <input *ngSwitchCase="'checkbox'" class="form-control" [(ngModel)]="formattedInputData[field.name]" name="{{ field.name }}" type="checkbox" />

            <select *ngSwitchCase="'select'" class="form-control" [(ngModel)]="selectedOptions[field.name]" name="{{ field.name }}" [compareWith]="compareEntity">
              <option *ngFor="let option of optionsData[field.entity]" [ngValue]="option">
                {{ option.name || option.description || option }}
              </option>
            </select>

            <div *ngSwitchCase="'text-with-similarity'" class="similarity-input-wrapper">
              <input
                class="form-control"
                [(ngModel)]="entityData[field.name]"
                (ngModelChange)="onSimilarityInputChange(field.name, $event)"
                name="{{ field.name }}"
                type="text"
                autocomplete="off" />

              <span class="status-pill"
                    *ngIf="similarityState[field.name]?.loading"
                    title="Buscando similitudes...">
                <span class="pill-dot pulse"></span>
                <span class="pill-text">Buscando...</span>
              </span>

              <span class="status-pill clickable"
                    *ngIf="!similarityState[field.name]?.loading && (similarityState[field.name]?.matches?.length || 0) > 0"
                    [class.exact]="similarityState[field.name].matches[0].similarity === 'exact'"
                    (click)="similarityState[field.name].showPanel = !similarityState[field.name].showPanel"
                    title="Click para ver detalles">
                <span class="pill-dot pulse"></span>
                <span class="pill-text">
                  {{ similarityState[field.name].matches.length }}
                  {{ similarityState[field.name].matches[0].similarity === 'exact' ? 'idéntico' : 'similar' }}{{ similarityState[field.name].matches.length === 1 ? '' : 'es' }}
                </span>
              </span>

              <div class="similarity-panel"
                   *ngIf="similarityState[field.name]?.showPanel && (similarityState[field.name]?.matches?.length || 0) > 0">
                <div class="panel-header">
                  <span>>_ SISTEMAS SIMILARES EXISTENTES</span>
                  <button type="button" class="panel-close" (click)="dismissSimilarityPanel(field.name)" aria-label="Cerrar">
                    <svg viewBox="0 0 24 24" width="12" height="12"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                  </button>
                </div>
                <div class="panel-hint">
                  Considera unificar la nomenclatura clicando en uno de los nombres existentes.
                </div>
                <ul class="match-list">
                  <li *ngFor="let match of similarityState[field.name].matches" class="match-item">
                    <div class="match-info" (click)="applySimilarSuggestion(field.name, match)">
                      <span class="match-name">{{ match.name }}</span>
                      <span class="match-meta">
                        <span class="match-client" *ngIf="match.client">{{ match.client.name }}</span>
                        <span class="match-badge" [class.exact]="match.similarity === 'exact'">
                          {{ match.similarity === 'exact' ? 'idéntico' : 'muy similar' }}
                        </span>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <input *ngSwitchCase="'readonly-derived'"
                   class="form-control readonly-derived"
                   [value]="derivedValues[field.name] || ''"
                   name="{{ field.name }}"
                   type="text"
                   readonly
                   tabindex="-1" />

          </ng-container>
        </div>
      </ng-container>
    </div>

    <!-- 1c: bloque multi-choice. Bifurcación:
         - Si el field tiene 'interactive: true', renderiza <app-multi-select>
           que permite seleccionar/deseleccionar items.
         - Si no, mantiene el visualizador read-only original
           (chips Cyber-Minimalist sin posibilidad de edición).
    -->
    <div class="form-grid multi-choice-grid">
      <ng-container *ngFor="let field of fields">

        <!-- 1c-UX: caso INTERACTIVO. La clase 'multi-select-group' marca el
             grupo para que el SCSS le aplique grid-column: span 2 (el doble
             ancho que los demás campos del form). Patrón estándar 2026 para
             multi-selects en formularios densos. -->
        <div class="form-group multi-select-group"
             *ngIf="canShowField(field) && field.type === 'multi-choice' && field.interactive">
          <label>{{ field.label }}</label>
          <app-multi-select
            [items]="optionsData[field.entity] || []"
            [selected]="selectedOptions[field.name] || []"
            [displayField]="'name'"
            [trackBy]="'id'"
            [placeholder]="'Seleccionar ' + field.label.toLowerCase() + '...'"
            (selectionChange)="onMultiSelectChange(field.name, $event)">
          </app-multi-select>
        </div>

        <!-- NO INTERACTIVO (comportamiento original, visualizador only) -->
        <div class="form-group"
             *ngIf="canShowField(field) && field.type === 'multi-choice' && !field.interactive">
          <label *ngIf="selectedOptions[field.name] && selectedOptions[field.name].length > 0">{{ field.label }}</label>
          <div class="selected-options-container" *ngIf="selectedOptions[field.name] && selectedOptions[field.name].length > 0">
            <span *ngFor="let option of selectedOptions[field.name]" class="cyber-badge">
              {{ option.name || option.description || option }}
            </span>
          </div>
        </div>

      </ng-container>
    </div>

    <div class="button-group">
      <button class="btn secondary" type="button" (click)="clearForm()">Limpiar</button>
      <button class="btn secondary" type="button" (click)="cancel()">Cancelar</button>
      <button class="btn danger" type="button" (click)="deleteEntity()">Borrar</button>
      <button class="btn primary btn-glow" type="button" (click)="saveEntity()">Guardar Datos</button>
    </div>
  </form>
</div>